import React, { createContext, useContext, useState, useEffect } from 'react';
import {
  getLevels,
} from './BasejumpApiProvider';
import { useTokenAuth } from '../hooks';
import { DiscordSdkContext } from './DiscordSdkProvider';

const UNKNOWN_AVATAR_DATA = {
  name: '?',
  avatar_type: 'custom',
  traits: [],
  baseline_stats: {},
  permanent_modifiers: {},
  thumbnail_url: '/assets/add_broadsider.svg',
  vrm_url: '/mocks/figures/Broadside_7160.vrm',
  glb_url: '/mocks/figures/Broadside_7160.glb',
  image_url: '/assets/add_broadsider.svg'
};

export const LevelContext = createContext();

export const LevelProvider = ({ children }) => {
  const { isDiscord } = useContext(DiscordSdkContext);
  const { basejumpToken } = useTokenAuth();
  const [levels, setLevels] = useState([]);

  const fetchLevels = async () => {
    const levelsFromBackend = await getLevels(basejumpToken);
    // Overwrite owner name with avatar name
    levelsFromBackend.forEach((l) => {
      if (!l.locked) {
        l.avatar.owner = {id: l.avatar.owner, user_name: l.avatar.name, isNpc: true}
      } else {
        l.avatar = { ... UNKNOWN_AVATAR_DATA, id: Math.random(), owner: { id: null, user_name: 'unknown', isNpc: true },  }
      }
    });
    setLevels(levelsFromBackend);
  };

  useEffect(() => {
    (async () => {
      if (basejumpToken) {
        await fetchLevels();
      }
    })();
  }, [basejumpToken]);

  const value = {
    levels,
    fetchLevels
  };

  return (
    <LevelContext.Provider value={value}>
      {children}
    </LevelContext.Provider>
  );
};
